function IconAntifraudeSemAnalise(props) {
  return (
    <svg 
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 25 25"
    width={props.width ? props.width : '25'}
    height={props.height ? props.height : '25'}
    fill="none"
    style={{ paddingRight: props.paddingRight }}
    >
      <path 
        fill={props.color ? props.color : '#BCBCBC'}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21 11c0 5.55-3.84 10.74-9 12c-5.16-1.26-9-6.45-9-12V5l9-4l9 4zm-9 10c3.75-1 7-5.46 7-9.78V6.3l-7-3.12L5 6.3v4.92C5 15.54 8.25 20 12 21m2.8-10V9.5C14.8 8.1 13.4 7 12 7S9.2 8.1 9.2 9.5V11c-.6 0-1.2.6-1.2 1.2v3.5c0 .7.6 1.3 1.2 1.3h5.5c.7 0 1.3-.6 1.3-1.2v-3.5c0-.7-.6-1.3-1.2-1.3m-1.3 0h-3V9.5c0-.8.7-1.3 1.5-1.3s1.5.5 1.5 1.3z"
      />
    </svg>

  );
}

export default IconAntifraudeSemAnalise;
